import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { SIDE_MENU_ITEMS } from './constants/side-menu-items';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ShowFullTextDirective } from '../../shared/directives/show-full-text.directive';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutService } from '../layout-service';
import { SideMenuI } from '../../shared/interfaces/side-menu.interface';

@Component({
  selector: 'app-side-menu',
  imports: [
    RouterLink,
    RouterLinkActive,
    ShowFullTextDirective,
    TranslateModule
],
  templateUrl: './side-menu.html',
  styleUrl: './side-menu.scss',
})
export class SideMenu implements OnInit {
  private readonly router = inject(Router);
  private readonly layoutService = inject(LayoutService);
  constructor() {
    effect(() => {
      this.toggleSideMenu();
    });
  }

  sideMenuItems = SIDE_MENU_ITEMS;
  currentUrl: string = this.router.url.slice(1);
  itemOnHover: string | null = null;
  isSideMenuCollapsed = signal<boolean>(true);

  ngOnInit(): void {}

  itemBeingHovered(item: string | null) {
    this.itemOnHover = item;
  }
  sideMenuItemIcon(state: boolean, item: SideMenuI) {
    return state
      ? item.activeIcon
      : this.itemOnHover === item.route
      ? item.activeIcon
      : item.inactiveIcon;
  }
  toggleSideMenu() {
    this.isSideMenuCollapsed.update(() =>
      this.layoutService.isSideMenuCollapsed()
    );
  }
}
